<template>
  <div class="lawa-card d-flex flex-column shadow rounded">
    <div v-if="hasHeader" class="lawa-card-header border-bottom position-relative d-flex align-items-center px-3" :class="{ 'justify-content-between': avatar || name, 'justify-content-end': !avatar }">
      <div v-if="avatar" class="avatar-logo rounded-circle shadow" :style="{ 'background-image': 'url(' + avatar + ')'}"></div>
      <div v-else class="avatar-initials rounded-circle shadow">
        <BlockWithInitials :name="name"/>
      </div>
      <slot name="header"></slot>
    </div>
    <div class="lawa-card-body px-3" :class="{ 'pt-5': hasHeader && avatar, 'pt-4': !hasHeader || !avatar, 'pb-2': hasFooter, 'pb-4': !hasFooter }">
      <slot></slot>
    </div>
    <div v-if="hasFooter" class="lawa-card-footer p-3 border-top d-flex align-items-center justify-content-between">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'lawa-card',
  components: {
    BlockWithInitials: () => import('../../Ui/BlockWithInitials'),
  },
  props: {
    avatar: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
  },
  methods: {
    hasSlot (name = 'default') {
      return !!this.$slots[name] || !!this.$scopedSlots[name];
    },
  },
  computed: {
    hasHeader () {
      return this.hasSlot('header');
    },
    hasFooter () {
      return this.hasSlot('footer');
    },
  },
};

</script>

<style lang="scss">

.lawa-card {
  .lawa-card-header {
    min-height: 75px;
  }

  .avatar-logo,
  .avatar-initials {
    align-items: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-color: white;
    bottom: 0;
    display: flex;
    height: 55px;
    justify-content: center;
    position: relative;
    transform: translateY(50%);
    -webkit-transform: translateY(50%);
    width: 55px;

    @include media-breakpoint-up(sm) {
      height: 90px;
      transform: translateY(25%);
      width: 90px;
    }
  }
}

</style>
